const locationData = require('../assets/data/locationData');

function toCityName (code) {
  let airport = locationData.airports.find((airport) => airport.code.toLowerCase() === code.toLowerCase());
  if (airport) {
    let city = locationData.cities.find((city) => city.id.toLowerCase() === airport.cityId.toLowerCase());
    if (city) {
      return city.name;
    }
  }

  return code;
}

function toAirportName (code) {
  let airport = locationData.airports.find((airport) => airport.code.toLowerCase() === code.toLowerCase());
  if (airport) {
    return airport.name;
  }

  return code;
}

export default {toCityName, toAirportName}